export const navLinks = [
  { label: 'Home batteries', href: '/shop/home-batteries' },
  { label: 'Plug-in batteries', href: '/shop/plug-in' },
  { label: 'Power stations', href: '/shop/power-stations' },
  { label: 'Solar panels', href: '/shop/solar-panels' },
  { label: 'Inverters', href: '/shop/inverters' },
  { label: 'Accessories', href: '/shop/accessories' },
];

export const brands = ['Ampra', 'EcoFlow', 'Anker SOLIX', 'Zendure', 'BLUETTI', 'AlphaESS', 'Victron Energy', 'Huawei'];

export const footerColumns = [
  {
    title: 'Shop',
    links: [
      { label: 'Home batteries', href: '/shop/home-batteries' },
      { label: 'Plug-in batteries', href: '/shop/plug-in' },
      { label: 'Power stations', href: '/shop/power-stations' },
      { label: 'Solar panels', href: '/shop/solar-panels' },
      { label: 'Deals', href: '/deals' },
    ],
  },
  {
    title: 'Service',
    links: [
      { label: 'Contact', href: '/' },
      { label: 'Shipping & delivery', href: '/' },
      { label: 'Returns', href: '/' },
      { label: 'Warranty', href: '/' },
      { label: 'FAQ', href: '/' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About Ampra', href: '/' },
      { label: 'Showroom Utrecht', href: '/' },
      { label: 'Business customers', href: '/' },
      { label: 'Careers', href: '/' },
    ],
  },
];

export const paymentMethods = ['iDEAL', 'Klarna', 'Bancontact', 'PayPal', 'Visa', 'Mastercard'];
